import { z } from 'zod';

export type CarDamagePhoto = {
    id: number,
    content_type: string,
    name: string,
    path: string,
    path_small: string,
};

export const CarDamagePhotoSchema = z.object({
    id: z.number(),
    content_type: z.string(),
    name: z.string(),
    path: z.string(),
    path_small: z.string(),
});
